import styled from 'styled-components';
import { theme } from 'Ui';

type AlmaSteps = {
  title: string;
  paragraph: string;
  secondaryParagraph?: boolean;
};

const StepContainer = styled.div`
  border-radius: 7px;
  border: 0.5px solid var(--Border-default, #dedcdc);
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  max-width: 25.6rem;
  @media screen and (max-width: 48rem) {
    height: 13.3rem;
    max-width: 30rem;
  }
`;

const StepTitle = styled.div`
  color: ${theme.v2.black};
  font-family: var(--font-primary);
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
`;
const StepParagraph = styled.div`
  color: ${theme.v2.black};
  text-align: center;
  font-family: var(--font-primary);
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  align-items: center;
`;

const Badge = styled.div`
  border-radius: 30px;
  background: #fa5022;
  display: flex;
  width: 2.7rem;
  height: 2.7rem;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  color: ${theme.light.colors.white};
  text-align: center;
  font-family: var(--font-primary);
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const AlmaStep = ({
  title,
  paragraph,
  secondaryParagraph = false,
}: AlmaSteps) => {
  return (
    <StepContainer>
      <StepTitle>{title}</StepTitle>
      {secondaryParagraph && (
        <StepParagraph>
          <Badge>3x</Badge>
          <div style={{ padding: '0 8px' }}>ou</div>
          <Badge>4x</Badge>
        </StepParagraph>
      )}
      <StepParagraph>{paragraph}</StepParagraph>
    </StepContainer>
  );
};
